import { useTranslation } from 'react-i18next';
import {
  Training,
  Theme,
  Evaluation,
  Flag,
  DuoToneCourseFilled,
  DuoToneAssessmentFilled,
  DuoToneVacancyFilled,
} from '@teo/components/icons';
import { IconTile } from '@teo/components';

const NodeItem = ({ items, Icon, color, className, text }) => {
  return (
    <div className="flex items-center rounded-lg border p-3">
      <IconTile
        Icon={Icon}
        color={color}
        size="small_sm"
        className={className}
      />
      <p className="pl-4 text-base font-medium text-black">
        {items?.length} {text}
      </p>
    </div>
  );
};

export const LearnContent = ({ allNodes }) => {
  const { t } = useTranslation();

  const learningpath = allNodes?.filter((el) => el?.subType === 'learningpath');
  const training = allNodes?.filter((el) => el?.subType === 'training');
  const evaluation = allNodes?.filter((el) => el?.subType === 'evaluation');
  const milestone = allNodes?.filter((el) => el?.subType === 'milestone');
  const course = allNodes?.filter(
    (el) => el?.subType === 'course' || el?.subType === 'import'
  );

  const assessment = allNodes?.filter((el) => el?.subType === 'assessment');
  const leervacature = allNodes?.filter((el) => el?.subType === 'leervacature');

  return (
    <>
      <div className="flex flex-col gap-2">
        {learningpath?.length > 0 && (
          <NodeItem
            items={learningpath}
            Icon={Theme}
            color={'dark_blue'}
            text={
              learningpath?.length > 1
                ? t('pages.lp_landing.themes')
                : t('pages.lp_landing.theme')
            }
          />
        )}
        {course?.length > 0 && (
          <NodeItem
            items={course}
            Icon={DuoToneCourseFilled}
            color={'yellow'}
            className={'fill-primary-06 text-primary-01'}
            text={
              course?.length > 1
                ? t('pages.lp_landing.courses')
                : t('pages.lp_landing.course')
            }
          />
        )}
        {assessment?.length > 0 && (
          <NodeItem
            items={assessment}
            Icon={DuoToneAssessmentFilled}
            color={'red'}
            className={'fill-tint-red-dark text-tint-red-light'}
            text={
              assessment?.length > 1
                ? t('pages.lp_landing.assessments')
                : t('pages.lp_landing.assessment')
            }
          />
        )}
        {leervacature?.length > 0 && (
          <NodeItem
            items={leervacature}
            Icon={DuoToneVacancyFilled}
            color={'yellow'}
            className={'fill-error-04 text-error-04'}
            text={
              leervacature?.length > 1
                ? t('pages.lp_landing.vacancies')
                : t('pages.lp_landing.vacancy')
            }
          />
        )}
        {training?.length > 0 && (
          <NodeItem
            items={training}
            Icon={Training}
            color={'green'}
            text={
              training?.length > 1
                ? t('pages.lp_landing.trainings')
                : t('pages.lp_landing.training')
            }
          />
        )}
        {evaluation?.length > 0 && (
          <NodeItem
            items={evaluation}
            Icon={Evaluation}
            color={'purple'}
            text={
              evaluation?.length > 1
                ? t('pages.lp_landing.evaluations')
                : t('pages.lp_landing.evaluation')
            }
          />
        )}
        {milestone?.length > 0 && (
          <NodeItem
            items={milestone}
            Icon={Flag}
            color={'blue'}
            text={
              milestone?.length > 1
                ? t('pages.lp_landing.milestones')
                : t('pages.lp_landing.milestone')
            }
          />
        )}
      </div>
    </>
  );
};
